import React from 'react'
import { CustomMerchModule, CustomToutType } from '@/types'
import MerchModuleWrapper from '.'

const PromoBanners = ({
  merchModules,
  isUsingNewLayout = false
}: {
  merchModules: CustomToutType[] | CustomMerchModule[]
  isUsingNewLayout?: boolean
}) => {
  return merchModules.length > 0 ? (
    <>
      {merchModules.map(merchModule => {
        return (
          <React.Fragment key={merchModule?.internalName}>
            <MerchModuleWrapper
              content={merchModule}
              isUsingNewLayout={isUsingNewLayout}
            />
          </React.Fragment>
        )
      })}
    </>
  ) : null
}

export default PromoBanners
